import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        gupiaolist_sz: null,        // 沪深3000+列表
        gupiaolist_dp: null,        // 大盘3条列表
        gp_keys_sz: [],             // 沪深3000+ keys
        gp_keys_cy: [],             // 创业板 keys
        gp_keys_zx: [],             // 中小板 keys
        gp_keys_kc: [],             // 科创板 keys
        gp_keys_zi: [],             // 自选股 keys
        hideFooter: false,          // 是否隐藏底部，自动计算上边的窗口大小, 自动重绘分时和k线图
        hideFooterTime: 0,          // 是否隐藏底部，自动计算上边的窗口大小, 自动重绘分时和k线图
        now_trade_account: '',      // 当前登录的用户名
        now_token: '',              // 当前登录的token
        now_chois_gp_item: null,    // 当前激活的股票
        accounts: {},               // 当前用户登录的所有账户
        can_money: null,            // 当前账户可用资金
        account_info: null,         // 当前交易账户信息
        upZixuan: null,             // 更新自选股，当添加和删除时候有用
        scroll_to_item: null,       // 滚动到指定位置
        account_info_need_up: null, // 交易账户信息需要更新
        right_info: null,           // 交易后右侧持仓等信息要更新下
        socket_codes: [],           // 要推送的codes, 行情页面，要更新的所有股票
        socket_codes2: [],           // 要推送的codes2, 下边需要更新的codes
        socket_codes3: [],           // 要推送的codes2, 个股
        isopen: false,           // 是否今日开盘
        nowTime: 0,           // 是否今日开盘
    },
    // 同步
    mutations: {
        SET_NOW_TIME(state, time) {
            state.nowTime = time;
        },
        SET_ISOPEN(state, isopen) {
            state.isopen = isopen;
        },
        // 全局保存股票列表信息
        SET_GUPIAO_LIST(state, obj) {
            switch (obj.b) {
                case 0:
                    state.gupiaolist_dp = obj.a;
                    break;
                case 1:
                    state.gupiaolist_sz = obj.a;
                    state.gp_keys_sz = obj.a.result;
                    break;
                case 2:
                    state.gp_keys_zx = obj.a.result;
                    break;
                case 3:
                    state.gp_keys_cy = obj.a.result;
                    break;
                case 4:
                    state.gp_keys_kc = obj.a.result;
                    break;
                case 5:
                    // 坑爹的玩意，返回code不行啊，不能带上sh，sz吗
                    state.gp_keys_zi = [];
                    if(obj.a) {
                        obj.a.result.map(v => {
                            const code = (v.substr(0, 1) === '6' ? 'sh' + v : 'sz' + v)
                            state.gp_keys_zi.push(code);
                        });
                    }
                    break;
            }
        },
        // 底部隐藏状态
        HIDE_FOOTER(state, yes) {
            state.hideFooter = yes.show;
            state.hideFooterTime = yes.time;
        },
        // 自动登录并保存登录信息
        SET_UID(state) {
            state.now_trade_account = sessionStorage.getItem('trade_account');
            state.now_token = sessionStorage.getItem('token');
            state.accounts = JSON.parse(sessionStorage.getItem('accounts'));
            if (!state.accounts) {
                state.accounts = {};
                state.accounts[state.now_trade_account] = {
                    account: state.now_trade_account,
                    token: state.now_token
                };
                sessionStorage.setItem('accounts', state.accounts)
            }
        },
        // 切换账户
        CHANGE_ACCOUNT(state, account) {
            state.now_trade_account = account;
            state.now_token = state.accounts[account].token;
            sessionStorage.setItem('token', state.accounts[account].token);
            sessionStorage.setItem('trade_account', account);
        },
        // 保存登录账户
        SET_LOGIN(state, data) {
            state.now_trade_account = data.user.trade_account;
            state.now_token = data.user.token;
            state.accounts[data.user.trade_account] = {
                account: data.user.trade_account,
                token: data.user.token
            };
            sessionStorage.setItem('accounts', JSON.stringify(state.accounts));
            sessionStorage.setItem('token', data.user.token);
            sessionStorage.setItem('trade_account', data.user.trade_account);
        },
        // 设置激活的股票
        SET_FOUCS_GP(state, code) {
            const gpItem = state.gupiaolist_sz.entities.patrons;
            if (gpItem.hasOwnProperty(code)) {
                state.now_chois_gp_item = gpItem[code];
                localStorage.setItem('now_gp', code)
            } else {
                state.now_chois_gp_item = null;
                localStorage.removeItem('now_gp')
            }
        },
        // 滚动到指定位置
        SCROLL_TO_ITEM(state) {
            state.scroll_to_item = Math.random() * 9999;
        },
        // 设置激活的大盘
        SET_FOUCS_DP(state, code) {
            const gpItem = state.gupiaolist_dp.entities.patrons;
            if (gpItem.hasOwnProperty(code)) {
                state.now_chois_dp_item = gpItem[code];
                localStorage.setItem('now_gp', code)
            } else {
                state.now_chois_dp_item = null;
                localStorage.removeItem('now_gp')
            }
        },
        /**
         * 更新股票列表中的股票行情
         * @param state
         * @param gp
         * @constructor
         */
        UPDATE_GP_DETAIL(state, gp) {
            if(state.gupiaolist_sz && gp.data) {
                const gpItem = state.gupiaolist_sz.entities.patrons;
                gp.data.forEach(item => {
                    // 偶尔会出现null的结果
                    if(!item.symbol) {
                        return true;
                    }
                    const code = (item.symbol.substr(0, 1) === '6' ? 'sh' + item.symbol : 'sz' + item.symbol);
                    // 更新股票列表
                    if (gpItem.hasOwnProperty(code)) {
                        gpItem[code] = Object.assign({}, gpItem[code], item);
                    }
                    // 更新当前激活的股票
                    if (state.now_chois_gp_item && state.now_chois_gp_item.code === code) {
                        state.now_chois_gp_item = Object.assign({}, state.now_chois_gp_item, item);
                    }
                })
            }
        },
        // 更新当前激活的股票
        UPDATE_DP_FOUCS_DETAIL(state, gp) {
            if (state.now_chois_dp_item && state.now_chois_dp_item.code === gp.code) {
                state.now_chois_dp_item = Object.assign({}, state.now_chois_dp_item, gp.item);
            }
        },
        // 设置账户信息或者更新账户信息
        UPDATE_ACCOUNT_INFO(state, data) {
            if(data) {
                state.account_info = data;
            } else {
                state.account_info_need_up = Math.random() * 9999;
            }
        },
        // 刷新可以使用的余额
        UPDATE_CAN_MONEY(state, data) {
            state.can_money = data;
        },
        // 购买后，通知更新右侧信息
        UPDATE_RIGHT_INFO(state) {
            state.right_info = Math.random() * 9999;
        },
        // 更新自选列表
        UP_ZIXUAN(state, randoms) {
            state.upZixuan = randoms;
        },
        /**
         * 更新要推送的ID列表
         * @constructor
         */
        UPDATE_SOCKET_IDS(state, data) {
            if(data.t === 'gpList') {
                state.socket_codes = data.code_s;
            } else if(data.t === 'detail') {
                state.socket_codes3 = data.code_s;
            } else if(data.t === 'join') {
                if(state.socket_codes.indexOf(data.code_s) === -1) {
                    state.socket_codes.push(data.code_s);
                }
            } else {
                state.socket_codes2 = data.code_s;
            }
        },
    },
    // 异步
    actions: {}
});

export default store;
